import axios from 'axios';
import qs from 'qs';
import router from '@/router';
import CryptoJS from 'crypto-js';
import { Message } from 'element-ui';
const private_key = 'nBHwb0U9mjViEMDsvQrqNhX6ITotuaWJ';

// -------------------------------------- 初始化axios ------------------------------------------
const service = axios.create({
    timeout: 5000 * 10,
    withCredentials: false,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    // baseURL: 'https://api.buman.hyebird.cn'
    baseURL:'https://api.webbuman.hyebird.cn'
});
// 请求拦截
service.interceptors.request.use(
    (request) => {
        request.headers['Accept'] = 'application/json';
        request.headers = { ...request.headers, ...request.header };
        // 这里判断工厂接口 还是之前的后台接口
        console.log( request.url.indexOf('/factoryapi'));
        if(request.url.indexOf('/factoryapi')!=-1){
            request.headers['Authorization'] = localStorage.getItem('pdaToken');
        }else{
            if (localStorage.getItem('token')) {
                request.headers['Authorization'] = localStorage.getItem('token');
            }
        }
      
        // 添加密钥
        var data = null;
        if (request.url == '/clientapi/payment' && request.method != 'get') {
            request.headers['Content-Type'] = 'multipart/form-data';
            data = request.data;
            request.data = data;
        } else {
            if (request.method == 'post' || request.method == 'put' || request.method == 'patch') {
                data = JSON.parse(JSON.stringify(request.data));
                request.data = qs.stringify(data);
            } else if (request.method == 'delete') {
                data = JSON.parse(JSON.stringify(request.params));
                request.data = qs.stringify(data);
            } else {
                data = JSON.parse(JSON.stringify(request.params));
            }
        }
        for (var i in data) {
            if (data[i] === '') {
                delete data[i];
            }
        }
        var timestamp = parseInt(new Date().getTime() / 1000);
        data['timestamp'] = timestamp;
        var sorted_keys = Object.keys(data).sort();
        var sign_str = '';
        for (var item in sorted_keys) {
            var key = sorted_keys[item];
            if (key !== 'sign' && key !== 'key') {
                sign_str += key + '=' + data[key];
            }
        }
        sign_str += 'key=' + private_key;
        // request.headers.timestamp = timestamp;
        request.headers['timestamp'] = timestamp;
        request.headers['sign'] = CryptoJS.MD5(sign_str).toString();
        return request;
    },
    (error) => {
        return Promise.reject(error);
    }
);
// 响应拦截
service.interceptors.response.use(
    (res) => {
        // let a='3wNK/kwECHIvoMPE7ySQuKxUXqA164iS30Nl3jKoi+DODNWcsMFLp/aWx1E6m6L9dM0lzUvz1hp16E98yVT+EbvqXVGsGtdcEpG7n6GXUsI='
        // console.log( CryptoJS.enc.Utf8.stringify(a),1)
        var data = res.data;
        let key = CryptoJS.enc.Utf8.parse(private_key);
        let decrypt = CryptoJS.AES.decrypt(data, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        data = CryptoJS.enc.Utf8.stringify(decrypt);
        data = JSON.parse(data);
     
        return data;
    },
    (error) => {
        if (!error.hasOwnProperty('response')) {
            return Promise.reject(error);
        }
        var data = error.response.data;
        let key = CryptoJS.enc.Utf8.parse(private_key);
        let decrypt = CryptoJS.AES.decrypt(data, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        data = CryptoJS.enc.Utf8.stringify(decrypt);

        data = JSON.parse(data);
        Message({
            showClose: true,
            message: data.msg,
            duration: 1500,
            type: 'error'
        });
        if (data.msg == 'token已失效') {
            localStorage.removeItem('user');
            localStorage.removeItem('auth_info');
            localStorage.removeItem('token');
            localStorage.removeItem('items');
            localStorage.removeItem('role_permission_info');
            router.push('/login');
        }
        return Promise.reject(data);
    }
);

// -------------------------------------- PUT ------------------------------------------
export function put(url = '', data = {}, header = {}) {
    return service({
        method: 'put',
        url: url,
        data: data
    });
}

// -------------------------------------- POST ------------------------------------------
export function post(url = '', data = {}, header = {}) {
    return service({
        method: 'post',
        url: url,
        data: data
    });
}

// -------------------------------------- GET ------------------------------------------
export function get(url = '', data = {}, header = {}) {
    return service({
        method: 'get',
        url: url,
        params: data
    });
}
// -------------------------------------- DELETE ------------------------------------------
export function del(url = '', data = {}, header = {}) {
    return service({
        method: 'delete',
        url: url,
        params: data
    });
}
